export default __webpack_public_path__ + "static/media/minusIcon.ca578791.svg";